<template>
  <div class="headerTopA">
    <div class="topEnglish" @click="changeEnglish">English</div>
  </div>
</template>

<script>
export default {
  name: "HeadTopA",
  data() {
    return {};
  },
  mounted() { },
  methods: {
    changeEnglish() {
      let toUrl = window.location.origin;
      window.location.href = `${toUrl}/en`;
    }
  }
};
</script>

<style scoped>
.headerTopA {
  max-width: 1920px;
  height: 5.55vh;
  background: url(../../assets/image/logotop.png) no-repeat center center;
  box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.34);
}

.headerTopA .topEnglish {
  width: 3.28125vw;
  height: 2.22vh;
  background: #ffffff;
  border-radius: 4px;
  font-weight: 400;
  font-size: 1.1111vh;
  color: #449088;
  text-align: center;
  line-height: 2.22vh;
  margin-top: 1.66667vh;
  margin-right: 1.4583vw;
  float: right;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/headTopA.vue